<template>
  <div>
    <!-- 上方主体 关于京数-->
    <div
      class="container_top"
      id="topCont"
      @mouseover="barNum = 0"
      v-if="contList"
    >
      <!-- 轮播图 -->
      <div class="topTitCont">
        <img
          style="width: 100%; display: block"
          :src="contList.picUrl"
          alt=""
        />
        <div class="cont_topTil">{{ contList.menuName }}</div>
        <!-- <div class="cont_topShad">Infrastructure services</div> -->
      </div>

      <div class="tapCont" id="menuTab">
        <div class="tapAll">
          <div class="tapTxt">
            <div
              v-for="(item, index) in contList.menuModule"
              :key="index"
              class="tapOne"
              :class="tapFlg == index ? 'colr' : ''"
              @click="tapClic(index)"
            >
              {{ item.title }}
            </div>
            <!-- <div
            class="tapOne"
            :class="tapFlg == 1 ? 'colr' : ''"
            @click="tapClic(1)"
          >
            {{ contList.menuModule[1].title }}
          </div> -->
          </div>
          <div class="memoryTap">
            <img
              @click="goHome('99')"
              style="margin: 0 10px; cursor: pointer"
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
              alt=""
            />
            <span
              style="cursor: pointer"
              @click="goHome('2', contList.parentId)"
              >{{ contList.parentName }}</span
            >
            <img
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
              alt=""
            />
            <span style="cursor: pointer" @click="goHome('2-2')">{{
              contList.menuName
            }}</span>
          </div>
        </div>
        <div
          :class="
            tapHomeFlg ? 'tapHome' : tapNum == 1 ? 'tapPackUp' : 'tapPack'
          "
        >
          <div class="topTabCont">
            <div class="tapTxt">
              <div
                v-for="(item, index) in contList.menuModule"
                :key="index"
                class="tapOne"
                :class="tapFlg == index ? 'colr' : ''"
                @click="tapClic(index)"
              >
                {{ item.title }}
              </div>
              <!-- <div
            class="tapOne"
            :class="tapFlg == 2 ? 'colr' : ''"
            @click="tapClic(2)"
          >
            方案优势
          </div> -->
            </div>
            <div class="memoryTap">
              <img
                @click="goHome('99')"
                style="margin: 0 10px; cursor: pointer"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
                alt=""
              />
              <span
                style="cursor: pointer"
                @click="goHome('2', contList.parentId)"
                >{{ contList.parentName }}</span
              >
              <img
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
                alt=""
              />
              <span style="cursor: pointer" @click="goHome('2-2')">{{
                contList.menuName
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 文字左右动态出现 公司简介-->
      <div
        class="companyProfile"
        id="companyProfile"
        ref="textCont"
        v-if="contList.menuModule && contList.menuModule.length > 0"
      >
        <div class="compe_tit">{{ contList.menuModule[0].title }}</div>
        <div class="compe_tit_fy">{{ contList.menuModule[0].titleEn }}</div>
        <div class="textCont">
          <div class="textLeft" :class="{ animLeft: textLeftFlg }">
            <img
              style="width: 100%"
              :src="contList.menuModule[0].detailsList[0].imgUrl"
              alt=""
            />
          </div>
          <div
            style="width: 47%; margin-left: 60px"
            :class="{ animRight: textRightFlg }"
          >
            <div class="textRight">
              <!-- <div class="companyTit">公司介绍</div> -->
              <div class="companyTxt">
                {{ contList.menuModule[0].detailsList[0].imgContent }}
                <!-- &emsp;&emsp;京数科技（上海）有限公司是一家专注为用户提供“移动安全通信”解决方案的互联网公司，通过软件、硬件与生产的结合，为企业提供完整的安全解决方案。<br />
              &emsp;&emsp;京数科技
              (上海)有限公司源自2012年成立于上海的张江安全工作室，专注于对移动数据安全传输与存储加密的研究，研发先进的三端加密安全系统。于2021年注册深圳，并于2022年进驻金桥成立京数科技。我们秉承国家大数据发展战略和关键设备自主可...... -->

                <!-- &emsp;&emsp;京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，
              通过软件与硬件的结合，为企业提供完整的安全体系产品。公司总部坐落于浦东新区张江科技园核心区。
            </div>
            <div class="companyTxt">
              &emsp;&emsp;2012年成立京数通讯系统安全工作室，专注于对移动数据安全传输与存储加密的研究，
              高起点介入从服务器端、信号传输端、终端设备的安全技术重塑，
              研发先进的三端加密安全系统，目前为全球第二家拥有同类系统的公司
              （另一家为海外公司），在私有化的支持上为全球唯一...... -->
              </div>
              <div style="display: flex; justify-content: end">
                <div
                  class="know"
                  @click="knowClick('7-1', contList.menuModule[0])"
                >
                  <a>了解更多 <i class="el-icon-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 公司资讯 -->
      <!-- <div class="companyInfo" id="companyInfo">
      <div class="coInfo_compe_tit">公司资讯</div>
      <div class="coInfoCont">
        <div class="coInfo_card">
          <img style="width: 100%" src="@/assets/aboutUs/Slice128.png" alt="" />
          <div class="coInfoBot_cont">
            <div class="coInfo_Tit">京数成立时间</div>
            <div>
              京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、
              存储解决方案”的互联网公司，通过软件与硬件的结合，为企业提供完整的安全体系产品。
              公司总部坐落于浦东新区张江科技园核心区。
            </div>
          </div>
        </div>
        <div class="coInfo_card">
          <img style="width: 100%" src="@/assets/aboutUs/Slice129.png" alt="" />
          <div class="coInfoBot_cont">
            <div class="coInfo_Tit">京数成立时间</div>
            <div>
              京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、
              存储解决方案”的互联网公司，通过软件与硬件的结合，为企业提供完整的安全体系产品。
              公司总部坐落于浦东新区张江科技园核心区。
            </div>
          </div>
        </div>
      </div>
      <div class="botConsult" @click="goMoreInquiy">
        <div>更多咨询&emsp;<i class="el-icon-right"></i></div>
      </div>
    </div> -->

      <!-- 团队介绍 -->
      <div
        class="teamIntro"
        id="teamIntro"
        v-if="contList.menuModule && contList.menuModule.length > 0"
      >
        <div class="team_compe_tit">{{ contList.menuModule[1].title }}</div>
        <div class="team_compe_fy">{{ contList.menuModule[1].titleEn }}</div>
        <div class="teamCont">
          <swiper :options="swiperTeam" ref="mySwiper">
            <swiper-slide
              class="my_slide"
              data-name="aboutUs/teamDetails"
              :data-tit="item.title"
              v-for="(item, index) in teamItems"
              :key="index"
              :data-id="index"
            >
              <div class="team_img">
                <img :src="item" alt="" />
              </div>
            </swiper-slide>
            <!-- <swiper-slide class="my_slide" data-name="aboutUs/teamDetails">
            <div class="team_img">
              <img src="@/assets/aboutUs/Slice125.png" alt="" />
              <div class="jobTit">
                <div>人物名称Character</div>
                <div>担任职位名称</div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="my_slide" data-name="aboutUs/teamDetails">
            <div class="team_img">
              <img src="@/assets/aboutUs/Slice126.png" alt="" />
              <div class="jobTit">
                <div>人物名称Character</div>
                <div>担任职位名称</div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="my_slide" data-name="aboutUs/teamDetails">
            <div class="team_img">
              <img src="@/assets/aboutUs/Slice127.png" alt="" />
              <div class="jobTit">
                <div>人物名称Character</div>
                <div>担任职位名称</div>
              </div>
            </div>
          </swiper-slide> -->
          </swiper>
          <div class="swiperLeft">
            <img
              style="width: 60%"
              src="https://oss.jingshucloud.com/gw-bucket/a8672b9e-faf3-42f1-b075-dc6c8cc128bc.png"
              alt=""
            />
            <img
              style="width: 60%"
              src="https://oss.jingshucloud.com/gw-bucket/25483f9d-5802-4cf3-a178-1ce7bc2b544a.png"
              alt=""
            />
          </div>
          <div class="swiperRight">
            <img
              style="width: 60%"
              src="https://oss.jingshucloud.com/gw-bucket/c26d827f-632e-4ea3-a7f1-19e0c05c908a.png"
              alt=""
            />
            <img
              style="width: 60%"
              src="https://oss.jingshucloud.com/gw-bucket/2dd3701b-53f9-4e84-b445-2130b311b05b.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- <div style="display: flex; justify-content: center; align-items: center">
      <div style="width: 100%; max-width: 1200px">
        <img style="width: 100%" src="@/assets/aboutUs/qiyjgjs.png" alt="" />
      </div>
    </div> -->
      <!-- 企业福利 -->
      <div
        class="welfareTreat"
        ref="welfom"
        id="customerValue"
        v-if="contList.menuModule && contList.menuModule.length > 0"
      >
        <div class="welf_compe_tit">{{ contList.menuModule[2].title }}</div>
        <div class="welf_compe_fy">{{ contList.menuModule[2].titleEn }}</div>

        <div class="swiperCont">
          <swiper
            style="padding: 30px 0px"
            :options="swiperOption"
            ref="mySwiper"
          >
            <swiper-slide
              class="succ_swiper"
              data-name="aboutUs/corporateWelfare"
              v-for="(item, index) in contList.menuModule[2].detailsList"
              :key="index"
            >
              <div class="succ_swiper_Cont">
                <img class="swiperBotImg" :src="item.imgUrl" alt="" />
              </div>
            </swiper-slide>
            <!-- <swiper-slide
            class="succ_swiper"
            data-name="aboutUs/corporateWelfare"
          >
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://oss.jingshucloud.com/gw-bucket/1d059761-d635-4a75-83e3-db351b6cf723.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide
            class="succ_swiper"
            data-name="aboutUs/corporateWelfare"
          >
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="https://oss.jingshucloud.com/gw-bucket/1027e10f-dd37-49ac-8e65-836cf0cd338f.png"
                alt=""
              />
            </div>
          </swiper-slide> -->
            <!-- <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="@/assets/enterprise/Slice53.png"
                alt=""
              />
            </div>
          </swiper-slide> -->
            <!-- <swiper-slide class="succ_swiper">
            <div class="succ_swiper_Cont">
              <img
                class="swiperBotImg"
                src="@/assets/enterprise/Slice56.png"
                alt=""
              />
            </div>
          </swiper-slide> -->
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div
        class="companyProfile"
        id="partner"
        ref="partner"
        v-if="contList.menuModule && contList.menuModule.length > 0"
      >
        <div class="compe_tit">{{ contList.menuModule[3].title }}</div>
        <div class="compe_tit_fy">{{ contList.menuModule[3].titleEn }}</div>
        <div class="partnerCont">
          <img :src="contList.menuModule[3].detailsList[0].imgUrl" alt="" />
          <div class="partner">
            <div class="partnerTit">
              {{ contList.menuModule[3].detailsList[0].contentTitle }}
            </div>
            <div class="partnerTxt">
              {{ contList.menuModule[3].detailsList[0].content }}
            </div>
            <div style="display: flex; justify-content: end">
              <div
                class="know"
                @click="knowClick('7-4', contList.menuModule[3])"
              >
                <a>成为合作伙伴 <i class="el-icon-arrow-right"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tel_Cont"
        ref="telCont"
        id="telCont"
        v-if="contList.menuModule && contList.menuModule.length > 0"
      >
        <div class="tel_Cont_tit">{{ contList.menuModule[4].title }}</div>
        <div class="tel_Cont_fy">{{ contList.menuModule[4].titleEn }}</div>
        <div class="telImg">
          <div class="telImgCont">
            <img :src="contList.menuModule[4].detailsList[0].imgUrl" alt="" />
            <div class="tellTxtCont">
              <div class="tellText">
                <div class="posReal">
                  <div>{{ contList.menuModule[4].detailsList[0].title }}</div>
                </div>
                <!-- <div style="font-size: 18px; margin-bottom: 20px">Contact us</div> -->
                <div
                  class="cont_topBut"
                  @click="knowClick('7-5', contList.menuModule[4])"
                >
                  了解更多
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="mobile">
      <xu-about-us />
    </div>
  </div>
</template>

<script>
var vm = null;
import { getCategoryInfo } from "@/api/index";
import XuAboutUs from "@/views/mobile/aboutUs.vue";
export default {
  props: { switchNum: String },
  components: { XuAboutUs },
  data() {
    return {
      teamInfo: [
        {
          name: "傅兆伟",
          jobTitle: "创始人& 首席执行官",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "二十年创业经验，涉及领域包括传统行业和互联网。2009年组建团队专为政府及商业合作伙伴提供大数据收集和分析业务。2012年创立vargo 安全通讯实验室，2014年创立瓦戈科技并担任CEO，同年公司受到IDG、红杉资本、经纬中国等重要基金合伙人天使轮投资。2015年初，瓦戈科技以3.5亿估值完成A轮融资，致力于为企业和党政机关等提供高效安全、可私有化部署、可定制的安全移动通信和数据存储产品和解决方案，并自主研发和创新相关软硬件产品，成为国内最具竞争优势的安全移动通信软硬件一体化解决方案供应商。",
        },
        {
          name: "戴立新",
          jobTitle: "EMBA 丨首席运营官",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "中欧国际工商学院EMBA、武汉理工大学硕士。曾任三一集团有限公司副总裁，二十年大型企业高级管理经验，对成本控制、费用管理、团队建设、文化传递、过程管理、人力资源管理等企业运营相关管理流程十分熟悉，有良好实施与推动的能力。 安全通讯实验室，2014年创立瓦戈科技并担任CEO，同年公司受到IDG、红杉资本、经纬中国等重要基金合伙人天使轮投资。2015年初，瓦戈科技以3.5亿估值完成A轮融资，致力于为企业和党政机关等提供高效安全、可私有化部署、可定制的安全移动通信和数据存储产品和解决方案，并自主研发和创新相关软硬件产品，成为国内最具竞争优势的安全移动通信软硬件一体化解决方案供应商。",
        },
        {
          name: "戴清平",
          jobTitle: "博士丨首席科学家",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "解放军某部退役人员，长期从事密码学与信息安全方面的教学、科研和产品研发工作。发表论文20多篇，参与973项目1项、863项目1项、自然科学基金5项，申请发明专利16项，出版教材专著5部。组织开发：智能密码钥匙、PCIe密码卡、密码机、防火墙、基于RISC-V的加密北斗芯片、物理隔离双系统智能终端、物理隔离单系统智能终端、天地一体化智能手机、标识密钥管理系统、行业级CA、加密邮件系统等。获军队科技进步一等奖1项、省级二等奖三等奖各1项，获军队育才奖银奖，立三等功1次。",
        },
        {
          name: "冯国柱",
          jobTitle: "博士丨首席安全官兼任密码技术部总监",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "毕业于国防科技大学，解放军某部退役人员，主要从事信息安全系统和密码应用研发十余年，任高级工程师，先后负责组织实施了十几个大小科研项目的设计和研发；熟悉PKI体系和算法、国密算法系列，负责并组织过企业级CA开发，擅长安全协议设计和密码应用研究；了解区块链相关技术和体系；熟练使用数据挖掘算法和数据过滤算法；在绿盟科技期间负责绿盟威胁建模体系设计及网络安全知识图谱建设，基于本体理论构造网络安全全景知识脉络，是绿盟未来产品规划的重要参考系和约束边界。获军队科技进步一等奖、二等奖各一项，三等奖三项。",
        },
        {
          name: "朱洪涛",
          jobTitle: "硕士丨执行合伙人",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "中国电子科技集团公司第三十二研究所所长助理、中电科华云信息技术有限公司董事、总经理。长期致力于中国信息化行业的发展，对云计算、大数据和行业信息化等领域关键技术有深刻理解并能够与业务实际相结合，对相关领域的市场、项目、产品、服务、运营有一套行之有效的方法和最佳实践，在企业战略规划、业务模式设计、核心产品规划、重大项目开拓、创新业务培育及企业资本运作方面都具备丰富的经验。",
        },
        {
          name: "李皓",
          jobTitle: "软件负责人",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "从事科技行业工作十余年，拥有深厚的专业研究与实战经验，擅长商业智能（BI）、大数据处理以及亿级用户服务系统构建。曾担任瓦力科技联合创始人和技术总监，成功推动公司发展并被小米科技收购；曾担任壕鑫互联CTO，助力企业A股上市；完成天地一体化第一代智能卫星手机的系统研发工作。",
        },
        {
          name: "康婷",
          jobTitle: "财务部总监",
          img: "https://oss.jingshucloud.com/gw-bucket/4d12aa2a-b2ae-4a79-8e3b-ba505352e725.png",
          txt: "从事财务管理工作17年，长期在上市公司和国企从事财务管理、内控、投融资的相关工作，具有扎实的帐务处理、投资分析、内部控制、运营管理、员工绩效考核的理论知识和娴熟的实务操作水平，熟悉各类融资业务，资金规划运作及资本市场运作，熟悉公司并购重组及不良资产处置，非常了解政府财政扶持和各项财政补贴的相关政策等。",
        },
        {
          name: "周金平",
          jobTitle: "销售部总监",
          img: "https://oss.jingshucloud.com/gw-bucket/d237a688-53e1-4f0d-83e6-75c8d78de88b.png",
          txt: "211大学自动化专业毕业，通信行业16年市场工作经验，深耕公安行业，JD行业市场，重大项目经验丰富，对行业市场有深刻的理解，在业内有丰富的生态资源，愿与业内的代理商和合作伙伴共同逐梦未来，成就客户。",
        },
        {
          name: "缪晶晶",
          jobTitle: "硬件负责人",
          img: "https://oss.jingshucloud.com/gw-bucket/4d12aa2a-b2ae-4a79-8e3b-ba505352e725.png",
          txt: "从事手机研发工作近20年，曾参与诺基亚feature phone和smart phone的测试开发工作；曾负责华为初代平板系列、荣耀系列、mate系列的相关开发和交付，以及武汉平板团队的业务培训；曾担任黑鲨部门总监，负责主导黑鲨全系手机开发和交付；完成天地一体化第一代智能卫星手机的研发和生产工作。",
        },
      ],
      teamItems: [
        require('@/assets/images/team/1.png'),
        require('@/assets/images/team/2.png'),
        require('@/assets/images/team/3.png'),
        require('@/assets/images/team/4.png'),
        require('@/assets/images/team/5.png'),
        require('@/assets/images/team/8.png'),
        require('@/assets/images/team/9.png')
      ],
      swiperTeam: {
        grabCursor: true,

        // 滑动方向
        direction: "horizontal",

        // 衔接滑动
        loop: true,
        // 自动滑动
        autoplay: {
          delay: 3000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false,
        },

        // 切换效果 "coverflow"（3d流）
        // effect: 'coverflow',

        // 设置slider容器能够同时显示的slides数量
        slidesPerView: "auto",
        //slider容器相互之间距离
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiperRight",
          prevEl: ".swiperLeft",
        },

        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        // centeredSlides: true,
        // on: {
        //   click: function () {
        //     console.log(
        //       this.clickedSlide.dataset,
        //       this.clickedSlide.dataset.name
        //     );
        //     if (this.clickedSlide && this.clickedSlide.dataset) {
        //       vm.goGave(
        //         this.clickedSlide.dataset.swiperSlideIndex,
        //         this.clickedSlide.dataset.name
        //       );
        //     }
        //   },
        // },

        // 设置为true则点击slide会过渡到这个slide。
        // slideToClickedSlide: true,

        // effect: "coverflow",
        // slidesPerView: 3,
        // centeredSlides: true,

        // coverflowEffect: {
        //   // slide做3d旋转时Y轴的旋转角度
        //   rotate: 0,
        //   // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
        //   stretch: 0,
        //   // slide的位置深度。值越大z轴距离越远，看起来越小。
        //   depth: 60,
        //   // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
        //   modifier: 5,
        //   // 是否开启slide阴影
        //   slideShadows: true
        // },
        freeMode: true,
        freeModeFluid: true,
        momentumRatio: 5,
      },
      swiperOption: {
        grabCursor: true,
        on: {
          click: function () {
            // console.log(
            //   this.clickedSlide.dataset,
            //   this.clickedSlide.dataset.name
            // );
            if (this.clickedSlide && this.clickedSlide.dataset) {
              vm.goWelfare(
                this.clickedSlide.dataset.swiperSlideIndex,
                this.clickedSlide.dataset.name
              );
            }
          },
        },

        // 滑动方向
        // direction: 'horizontal',

        // 衔接滑动
        loop: true,
        // 自动滑动
        // autoplay: {
        //   delay: 5000,
        //   // 如果设置为true，当切换到最后一个slide时停止自动切换。
        //   stopOnLastSlide: false,
        //   // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
        //   disableOnInteraction: false,
        // },

        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 3,
        //slider容器相互之间距离
        spaceBetween: 40,

        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        centeredSlides: true,

        // 设置为true则点击slide会过渡到这个slide。
        // slideToClickedSlide: true,

        effect: "coverflow",
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          paginationClickable: true,
        },
      },

      tapHomeFlg: false,
      tapNum: 0,
      textLeftFlg: false,
      textRightFlg: false,
      tapFlg: "0",
      contList: {},
      flgId: "",
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum",curVal, oldVal);

      if (curVal == 2) {
        document
          .getElementById("topCont")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    console.log(document.getElementById("menuTab").offsetHeight);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    vm = this;
    if (this.switchNum == 7) {
      document.getElementById("topCont").scrollIntoView({ behavior: "smooth" });
      this.textLeftFlg = true;
      this.textRightFlg = true;
    }
    console.log(this.switchNum, this.textLeftFlg);
    if (this.$route.params.id) {
      localStorage.setItem("menuId", this.$route.params.id);
    }
    console.log(localStorage.getItem("menuId"));
    this.flgId = localStorage.getItem("menuId");
    if (this.flgId) {
      getCategoryInfo(this.flgId).then((res) => {
        this.contList = res.data.data;
        console.log(this.contList);
      });
    }
  },
  methods: {
    gotempIndex() {
      this.$router.push({
        name: "serveButHome/onlineHome/tempIndex",
      });
    },
    goGave(row, name) {
      let sum = parseInt(row) + 1;
      let num = "3-" + sum;
      console.log("测试点击", num);
      this.$router.push({
        name: name,
        params: { info: this.teamInfo, id: row },
      });
      this.$store.commit("changeTabCheck", {
        idNum: "7-t",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    goWelfare(row, name) {
      console.log("测试点击", row, name);
      this.$router.push({
        name: name,
        params: {},
      });
      this.$store.commit("changeTabCheck", {
        idNum: "7-qy",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    tapClic(row) {
      this.tapFlg = row;
      if (row == 0) {
        document
          .getElementById("companyProfile")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 1) {
        document
          .getElementById("teamIntro")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 2) {
        document
          .getElementById("customerValue")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 3) {
        document
          .getElementById("partner")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 4) {
        document
          .getElementById("telCont")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
    knowClick(row, txt) {
      console.log(row,txt);
      if (row == "7-1") {
        this.$router.push({
          name: "aboutUs/companyIntro",
          params: { txt: txt },
        });
      }
      if (row == "7-4") {
        this.$router.push({
          name: "aboutJingshu/partnerIndex",
          params: { txt: txt },
        });
      }
      if (row == "7-5") {
        this.$router.push({
          name: "aboutJingshu/recruitment",
          params: { txt: txt },
        });
      }

      this.$store.commit("changeTabCheck", {
        idNum: row,
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    goHome(row, id) {
      this.$emit("switchflg", "0", row);
      if (row == "99") {
        this.$router.push({
          name: "myHome",
          params: {},
        });
      }
    },
    goMoreInquiy() {
      this.$router.push({
        name: "aboutUs/companyConsulting",
        params: {},
      });
      this.$store.commit("changeTabCheck", {
        idNum: "7-zx",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    handleScroll() {
      if (this.$refs.textCont && this.$refs.textCont.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.textCont.offsetTop,
        //   this.switchNum
        // );
        // if (this.switchNum == 0) {
        //   this.textLeftFlg = false;
        //   this.textRightFlg = false;
        // }

        if (window.scrollY > 850) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        // if (window.scrollY > 80) {
        //   this.textLeftFlg = true;
        //   this.textRightFlg = true;
        // }

        this.$emit("switchflg", "0");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.telImg {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -100px;
  margin-top: 80px;

  .telImgCont {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
  }
  .telImgCont::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 100%
    );
    z-index: 1;
  }
  .telImgCont img {
    // width: 1691px;
    width: 100%;
    // position: absolute;
    // z-index: 0;
  }
  .tellTxtCont {
    // width: 1691px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 20px;
    /*  小屏适配 */
    // width: 86%;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
  }
  .tellText {
    position: absolute;
    top: 100px;
    left: 7.6%;
    font-size: 46px;
    font-weight: 600;
    color: rgb(255, 255, 255);
    // width: 200px;
    /*  小屏适配 */
    left: 0;
    z-index: 2;
  }
  .posReal {
    position: relative;
    display: table;
    white-space: nowrap;
  }
  // .botWire::before {
  //   content: "";
  //   height: 1px;
  //   background: #fff;
  //   position: absolute;
  //   top: 51px;
  //   width: 100%;
  // }
  .cont_topBut {
    font-size: 20px;
    font-weight: 600;
    border: 2px solid white;
    white-space: nowrap;
    display: table;
    padding: 5px 20px;
    margin-top: 20px;
    cursor: pointer;
  }
  .cont_topBut:hover {
    border: 2px solid #04758e;
    background: #04758e;
  }
}
.container_top {
  width: 100%;
  .topTitCont {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    // left: 44%;
    font-size: 46px;
    font-weight: 600;
    color: white;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // flex-direction: column;
  }
}
// 文字菜单栏动画
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapOne {
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: "";
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  //tap动画
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .tapHome {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
  .topTabCont {
    width: 100%;
    max-width: 1230px;
    display: flex;
    justify-content: space-between;
  }
  .tapTxt {
    display: flex;
    justify-content: space-around;
    align-items: center;
    // margin-left: -20px;
  }
  .memoryTap {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .memoryTap img {
    width: 20px;
  }
}
.partnerCont {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin-top: 60px;
  align-items: center;
  flex-direction: column;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.06);
  img {
    width: 100%;
  }
  .partner {
    margin: 36px 44px;
  }
  .partnerTit {
    font-weight: bold;
    font-size: 36px;
    color: #151a23;
  }
  .partnerTxt {
    margin: 12px 0;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    line-height: 30px;
    letter-spacing: 2px;
  }
}

// 公司简介
.companyProfile {
  //   background: #f3f8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 105px;
  .textCont {
    // height: 500px;
    // margin: 80px 0 40px 0;
    // background: #003365;
    display: flex;
    justify-content: center;
    // align-items: center;
    width: 100%;
    max-width: 1200px;
    margin-top: 60px;
    align-items: center;
  }
  .compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    // margin-bottom: 60px;
    // width: 130px;
  }
  .compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 52px;
    width: 100%;
  }

  .compe_tit_fy {
    font-size: 20px;
    margin: 20px 0;
    color: #8a8c91;
  }

  .textLeft {
    // width: 50%;
    // margin: 0 40px;
    // text-align: right;
    display: flex;
    justify-content: left;
    // margin-right: 90px;
  }
  //   .textLeftCont {
  //     // width: 70%;
  //   }
  .textRight {
    width: 650px;
  }
  .companyTit {
    font-size: 24px;
    color: #151a23;
    margin-bottom: 30px;
  }
  .companyTxt {
    line-height: 30px;
    margin-bottom: 20px;
    text-align: justify;
    font-size: 20px;
    font-weight: 400;
    color: #151a23;
    white-space: pre-line;
    text-indent: 32px;
  }
  .know {
    cursor: pointer;
    margin: 0 5px;
    position: relative;
    text-decoration: none;
    display: table;
    white-space: nowrap;
  }
  .know::after {
    content: "";
    z-index: -1;
    position: absolute;
    background-color: #04758e;
    width: 100%;
    height: 10%;
    bottom: -2px;
    left: 0;
    visibility: hidden;
    transform: scaleX(0);
    transition: transform 200ms ease-in-out;
  }
  .know:hover::after {
    visibility: visible;
    transform: scaleX(1);
  }
  .know:hover {
    color: #04758e;
    // text-decoration: underline;
  }
  @keyframes companyTitright {
    0% {
      //   padding-left: 300px;
      // transform: translateX(300px);
      padding-right: -600px;
      opacity: 0;
    }
    100% {
      //   transform: translate(0);
      //   padding-left: 0px;
      padding-right: 0px;
      opacity: 1;
    }
  }
  @keyframes companyTitleft {
    0% {
      transform: translateX(-300px);
      //   padding-right: 600px;
      opacity: 0;
    }
    100% {
      transform: translateX(0px);
      //   padding-right: 0px;
      opacity: 1;
    }
  }
  //   .animLeft {
  //     // animation: companyTitleft 2s ease-out;
  //   }
  //   .animRight {
  //     // animation: companyTitright 2s ease-out;
  //   }
}

// 公司资讯
.companyInfo {
  background: #f3f8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 60px 0;
  .coInfo_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
    width: 130px;
  }
  .coInfo_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .coInfoCont {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 80px 150px 20px 150px;
    padding-top: 60px;
    width: 100%;
    max-width: 1230px;
  }
  .coInfo_card {
    margin: 0 15px;
  }
  .coInfoBot_cont {
    background: #fff;
    padding: 25px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  }
  .coInfo_card img {
    width: 100%;
    margin-bottom: -4px;
  }
  .coInfo_Tit {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 500;
  }
}

// 硬件定制服务
.teamIntro {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 60px 0;
  .team_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    // margin-bottom: 20px;
  }
  .team_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 52px;
    width: 100%;
  }

  .team_compe_fy {
    font-size: 20px;
    margin: 20px 0;
    color: #8a8c91;
  }
  .teamCont {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin: 80px;
    margin-top: 60px;
    width: 100%;
    max-width: 1230px;
    position: relative;
  }
  .my_slide {
    cursor: pointer;
    // margin: 0 20px;
    border-radius: 15px;
    font-size: 18px;
    // background: #fff;
    // height: 540px;
    // width: 420px !important;
    width: 330px !important;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // transition-property: all;
    // flex-direction: column;
    // text-align: center;
  }
  .swiperLeft {
    position: absolute;
    top: 38%;
    z-index: 99;
    cursor: pointer;
    left: -60px;
    background: rgb(255, 255, 255);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: rgba(118, 118, 118, 0.1) 0px 2px 10px 0px;
  }
  .swiperLeft :nth-child(2) {
    display: none;
  }
  .swiperLeft:hover :nth-child(2) {
    display: block;
  }
  .swiperLeft:hover {
    background: #04758e;
  }
  .swiperLeft:hover :nth-child(1) {
    display: none;
  }

  .swiperRight {
    position: absolute;
    top: 38%;
    z-index: 99;
    cursor: pointer;
    right: -75px;
    background: rgb(255, 255, 255);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: rgba(118, 118, 118, 0.1) 0px 2px 10px 0px;
  }
  .swiperRight :nth-child(2) {
    display: none;
  }
  .swiperRight:hover :nth-child(2) {
    display: block;
  }
  .swiperRight:hover {
    background: #04758e;
  }
  .swiperRight:hover :nth-child(1) {
    display: none;
  }
  .team_img {
    margin: 0 15px;
    position: relative;
  }
  .team_img img {
    // width: 100%;
    width: 100%;
  }
  .jobTit {
    position: absolute;
    bottom: 20px;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    z-index: 3;
  }
  .jobTit div:nth-child(2) {
    font-size: 14px;
    margin-top: 6px;
  }
  .shadeJob {
    position: absolute;
    // bottom: 6px;
    bottom: 0;
    width: 277px;
    height: 78px;
    background: #000000;
    opacity: 0.4;
    z-index: 2;
  }

  .teamLeft {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .team_text_Cont {
    width: 55%;
    line-height: 32px;
  }
  .team_tit {
    font-size: 21px;
    font-weight: 500;
    color: #151a23;
    line-height: 70px;
  }
  .teamRight {
    width: 50%;
  }
}

// 福利待遇
.welfareTreat {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding: 80px 105px;
  padding: 80px 58px;
  .welf_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
    width: 130px;
  }
  .welf_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 52px;
    width: 100%;
  }
  .welf_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .welfCont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 80px 0;
  }
  // 福利待遇轮播
  .swiperCont {
    margin: 5% 0;
    // width: 100%;
    width: 1495px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1200px;
  }
  .succ_swiper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .succ_swiper_Cont {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  // .swiper-slide {
  //   // margin-right: 0px !important;
  //   // margin-right: 40px !important;
  //   // margin-left: 40px;
  //   // width: 400px !important;
  // }
  .swiper_Cont_left {
    padding: 55px 0 25px 11%;
  }
  .swiper_top_img {
    width: 9%;
    margin-bottom: 20px;
  }
  .swiper_time {
    color: #7bb7c6;
    font-size: 28px;
  }
  .swiper_Tit {
    width: 50%;
    font-size: 22px;
    margin: 30px 0;
  }
  .swiperBot_txt {
    line-height: 25px;
    width: 50%;
  }
  .swiperBotImg {
    width: 100%;
    width: 370px;
    height: 240px;
  }
}
.tel_Cont {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding: 80px 105px;
  // padding: 80px 58px;
  .tel_Cont_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
    // width: 130px;
  }
  .tel_Cont_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 52px;
    width: 100%;
  }
  .tel_Cont_fy {
    font-size: 20px;
    color: #8a8c91;
  }
}

.botConsult {
  // height: 100%;
  background: #fff;
  // padding: 80px;
  // height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.botConsult div {
  color: #fff;
  cursor: pointer;
  background: #04758e;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-radius: 6px;
}
.botConsult i {
  font-size: 22px;
}
</style>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
